export default "/eb1b73cf75f302d63b0b9bd9835c1038cae47005/a92d826d80900dda6092d3b109ffaee1.svg";